import { createContext } from "@-/com.npmjs.use-context-selectors";
import { defaultError } from "@-/com.npmjs.react-context-default-error";
import { useActorDatabaseContextValue } from "#actor-database-context-value";

export type ActorDatabaseContextValue = ReturnType<typeof useActorDatabaseContextValue>;

export const ActorDatabaseContext = createContext(
  defaultError<ActorDatabaseContextValue>("ActorDatabaseContext"),
);
